"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var View_1 = require("../View");
var PageWizardBody_1 = require("./PageWizardBody");
var PageWizardFooter_1 = require("./PageWizardFooter");
var WizardProgress_1 = require("./WizardProgress");
var Overlay_1 = require("../Overlay");
var WizardPanelContainer_1 = require("../WizardPanelContainer");
var helpers_1 = require("../helpers");
var hooks_1 = require("./hooks");
var zIndexManager_1 = require("../helpers/zIndexManager");
var StackView_1 = require("../StackView");
var FOOTER_HEIGHT = helpers_1.SPACING_XXXL;
var WrapperTabs = styled_components_1.default(StackView_1.StackView)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var WrapperBody = styled_components_1.default(StackView_1.StackView)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex: 1;\n"], ["\n    flex: 1;\n"])));
var StyledPageWizardProgress = styled_components_1.default(WizardProgress_1.PageWizardProgress)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n"], ["\n    ",
    "\n"])), function (_a) {
    var fullHeight = _a.fullHeight;
    return !fullHeight && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            bottom: ", ";\n        "], ["\n            bottom: ", ";\n        "])), FOOTER_HEIGHT);
});
var Body = styled_components_1.default(StackView_1.StackView)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    position: relative;\n    flex: 1;\n    overflow: hidden;\n"], ["\n    position: relative;\n    flex: 1;\n    overflow: hidden;\n"])));
var Inner = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: flex;\n    flex: 1;\n    overflow: hidden;\n    flex-direction: column;\n    position: relative;\n"], ["\n    display: flex;\n    flex: 1;\n    overflow: hidden;\n    flex-direction: column;\n    position: relative;\n"])));
function PanelContainer(_a) {
    var panel = _a.panel, panelMinWidth = _a.panelMinWidth, panelWidth = _a.panelWidth, shrinkPanel = _a.shrinkPanel;
    var panelApi = react_1.useContext(hooks_1.PageWizardPanelContext);
    panel = panel || panelApi.element;
    if (!panel) {
        return null;
    }
    return (react_1.default.createElement(Overlay_1.Overlay, { view: Overlay_1.OVERLAY_VIEW.tone, contentMod: Overlay_1.OVERLAY_CONTENT_MOD.right },
        react_1.default.createElement(WizardPanelContainer_1.WizardPanelContainer, { panel: panel, panelMinWidth: panelMinWidth, panelWidth: panelWidth, shrinkPanel: shrinkPanel || panelApi.isShrink })));
}
var Footer = styled_components_1.default(StackView_1.StackView)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    height: ", ";\n    background-color: ", ";\n"], ["\n    height: ", ";\n    background-color: ", ";\n"])), FOOTER_HEIGHT, function (_a) {
    var theme = _a.theme;
    return theme.colorHighlightNotification;
});
exports.PageWizardLayout = helpers_1.createUIElement('PageWizardLayout', function (_a, ref) {
    var className = _a.className, header = _a.header, tabs = _a.tabs, content = _a.content, footer = _a.footer, loading = _a.loading, panel = _a.panel, _b = _a.panelMinWidth, panelMinWidth = _b === void 0 ? '768px' : _b, _c = _a.panelWidth, panelWidth = _c === void 0 ? '50%' : _c, _d = _a.shrinkPanel, shrinkPanel = _d === void 0 ? false : _d, pending = _a.pending, fullWidthContent = _a.fullWidthContent, _e = _a.widthContent, widthContent = _e === void 0 ? '800px' : _e, onRequestClose = _a.onRequestClose, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "header", "tabs", "content", "footer", "loading", "panel", "panelMinWidth", "panelWidth", "shrinkPanel", "pending", "fullWidthContent", "widthContent", "onRequestClose", "onKeyPress", "style"]);
    zIndexManager_1.useZIndexManager({
        onKeyPress: function (e) {
            if (e.keyCode === helpers_1.KeyCode.Escape) {
                onRequestClose === null || onRequestClose === void 0 ? void 0 : onRequestClose();
            }
            onKeyPress === null || onKeyPress === void 0 ? void 0 : onKeyPress(e);
        }
    });
    return (react_1.default.createElement(hooks_1.PageWizardPanelProvider, null,
        react_1.default.createElement(StackView_1.StackView, __assign({}, rest, { testId: rest['data-selector-id'] || 'pagewizard-layout', className: "vm-PageWizardLayout " + className, tabIndex: -1, direction: StackView_1.STACK_DIRECTION.column, spaceFill: View_1.SPACE_FILL.all, backgroundView: View_1.VIEW_BG_VIEW.normal, ref: ref, style: style }),
            header,
            react_1.default.createElement(Inner, null,
                react_1.default.createElement(Body, null,
                    react_1.default.createElement(WrapperTabs, { direction: StackView_1.STACK_DIRECTION.column, distribution: StackView_1.STACK_DISTRIBUTION.firstFill },
                        tabs,
                        !fullWidthContent && react_1.default.createElement(Footer, null)),
                    react_1.default.createElement(WrapperBody, { direction: StackView_1.STACK_DIRECTION.column },
                        react_1.default.createElement(PageWizardBody_1.PageWizardBody, { widthContent: widthContent, fullWidthContent: fullWidthContent }, content),
                        !fullWidthContent && (react_1.default.createElement(Footer, null,
                            react_1.default.createElement(PageWizardFooter_1.PageWizardFooter, { widthContent: widthContent, fullWidthContent: fullWidthContent }, footer)))),
                    (loading || pending) && (react_1.default.createElement(StyledPageWizardProgress, { fullHeight: !!fullWidthContent, block: loading }))),
                fullWidthContent && (react_1.default.createElement(PageWizardFooter_1.PageWizardFooter, { widthContent: widthContent, fullWidthContent: fullWidthContent }, footer)),
                react_1.default.createElement(PanelContainer, { panel: panel, panelMinWidth: panelMinWidth, panelWidth: panelWidth, shrinkPanel: shrinkPanel })))));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=PageWizardLayout.js.map